import React from "react";
import moment from "moment";
import twix from "twix";
import { Link } from "react-router";
import copy from "copy-to-clipboard";

import config from "../config";
import * as util from "../util";
import { Tabs, Tab, RaisedButton, Styles } from "material-ui";

import EventTicketSalesChart from "./partials/event-ticket-sales-chart.jsx";
import TicketTable from "./partials/ticket-table.jsx";
import EventAnalyticsWidget from "./partials/event-analytics-widget.jsx";

import WorkingIndicator from "./partials/working-indicator.jsx";
import BackButton from "./partials/back-button.jsx";
import ViewLiveVirtualButton from "./partials/view-live-virtual-button.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import EventActions from "../actions/EventActions";
import EventStore from "../stores/EventStore";
import EventBucketStore from "../stores/EventBucketStore";
import TicketActions from "../actions/TicketActions";
import TicketStore from "../stores/TicketStore";
import UserStore from "../stores/UserStore";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

import { makeEventDateRangeLabel } from "../util";

class Event extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "insights",
      isFetchingEvent: false,
      fetchedEvent: null
    };

    this.onChangeTab = this.onChangeTab.bind(this);

    this._makeInsights = this._makeInsights.bind(this);
    this._makeTickets = this._makeTickets.bind(this);
    this._makeExports = this._makeExports.bind(this);

    this._isRevshareView = this._isRevshareView.bind(this);
  }

  static getStores() {
    return [EventStore, EventBucketStore, TicketStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getEventById: EventStore.getEventById,
      getTicketsForEvent: TicketStore.getTicketsForEvent,
      apiKey: UserStore.getState().apiKey,
      isFetchingTickets: TicketStore.getState().isFetching,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  _isRevshareView() {
    return this.props.location.pathname.indexOf("/revenue_sharing") === 0;
  }

  onChangeTab(tab) {
    if (typeof tab !== "string") {
      return;
    } // propagation's a bitch
    this.context.router.push(
      `${
        this._isRevshareView()
          ? `/revenue_sharing`
          : `/event_buckets/${this.props.params.eventBucketId}/events`
      }/${this.props.params.eventId}` + (tab === "insights" ? "" : `/${tab}`)
    );
  }

  copyPublicLink(eventLink) {
    copy(eventLink);
    GlobalNotificationActions.notify.defer("Public link copied successfully!");
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var event = newProps.getEventById(newProps.params.eventId);

    if (
      !this.state.isFetchingEvent &&
      this.state.fetchedEvent !== newProps.params.eventId
    ) {
      EventActions.fetchOne(newProps.params.eventId);
      TicketActions.fetchAllForEvent(newProps.params.eventId);
      this.setState({ isFetchingEvent: true });
    } else if (event) {
      this.setState({ isFetchingEvent: false, fetchedEvent: event.id });
    }

    // Set tab; default to "insights"
    this.setState({ tab: newProps.params.tab || "insights" });
  }

  getStyles() {
    return {
      header: {
        main: {
          position: "relative",
          backgroundColor: "rgba(0,0,0,0.5)"
        },
        buttonContainer: {
          marginBottom: 5,
          float: "right"
        },
        button: {
          verticalAlign: "top",
          marginLeft: "1em"
        },
        text: {
          padding: "10px 10px",
          boxSizing: "border-box",
          width: "100%"
        },
        textContent: {
          color: "#fff",
          margin: 0
        }
      },
      container: {
        marginTop: 10
      },
      exportButton: {
        float: "left",
        clear: "both",
        marginBottom: 10
      },
      contentText: {
        fontSize: "12pt",
        color: "rgb(33,33,33)"
      }
    };
  }

  _makeInsights() {
    const styles = this.getStyles();

    return (
      <div style={styles.container}>
        <EventAnalyticsWidget eventId={this.props.params.eventId} />
      </div>
    );
  }

  _makeTickets() {
    const styles = this.getStyles(),
      event = this.props.getEventById(this.props.params.eventId),
      tickets = this.props.getTicketsForEvent(this.props.params.eventId),
      eventBucket = EventBucketStore.getEventBucketById(this.props.params.eventBucketId);

    return (
      <div style={styles.container}>
        <EventTicketSalesChart
          style={{ margin: "1em 0 1.5em" }}
          event={event.id}
        />
        <TicketTable
          tickets={tickets}
          event={event.id}
          eventDetails={event}
          isSundance={eventBucket && eventBucket.frontend_config ? eventBucket.frontend_config.sundance_login : false}
          isFetching={this.props.isFetchingTickets}
          showStats={true}
          showPerson={true}
          location={this.props.location}
          isRevshareView={this._isRevshareView()}
        />
      </div>
    );
  }

  _makeExports(eventDetails) {
    const styles = this.getStyles(),
      apiKey = this.props.apiKey,
      event = this.props.params.eventId;

    return (
      <div style={styles.container}>
        <p style={styles.contentText}>
          Generate exports related to "{eventDetails.name}".
        </p>
        <RaisedButton
          style={styles.exportButton}
          href={`${config.endpoint}events/${event}/attendees.pdf?api_key=${apiKey}`}
          target="_blank"
          label="Download attendees list (PDF)"
        />
        <RaisedButton
          style={styles.exportButton}
          href={`${config.endpoint}events/${event}/attendees.csv?api_key=${apiKey}`}
          target="_blank"
          label="Download attendees list (CSV)"
        />
        {!this._isRevshareView() ? (
          <RaisedButton
            style={styles.exportButton}
            href={`${config.endpoint}tickets.pdf?event=${event}&include_bulk_info=true&api_key=${apiKey}`}
            target="_blank"
            label="Download all tickets (PDF)"
          />
        ) : null}
        <RaisedButton
          style={styles.exportButton}
          href={`${config.endpoint}events/${event}/attendees.csv?scanned_only=true&api_key=${apiKey}`}
          target="_blank"
          label="Download scanned attendees (CSV)"
        />
        <h2
          style={Object.assign({}, styles.exportButton, {
            margin: "20px 0 15px"
          })}
        >
          Financial exports
        </h2>
        <RaisedButton
          style={styles.exportButton}
          onClick={() => {
            const form = document.createElement("form");
            form.method = "post";
            form.action = `${
              config.endpoint
            }analytics/ledger_transaction_report?conditions=${encodeURIComponent(
              JSON.stringify({ event_bucket: [eventDetails.event_bucket] })
            )}&options=${encodeURIComponent(
              JSON.stringify({
                format: "csv",
                timePeriod: "NO GROUPING",
                includeNameAndEmail: true,
                selectedEvent: [event]
              })
            )}&${UserStore.makeApiKeyQueryString()}`;
            document.body.appendChild(form);
            form.submit();
          }}
          label="Download all ledger transactions (CSV)"
        />
      </div>
    );
  }

  render() {
    const styles = this.getStyles(),
      event = this.props.getEventById(this.props.params.eventId),
      tickets = this.props.getTicketsForEvent(this.props.params.eventId),
      isRevshareView = this._isRevshareView();

    if (!event) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <div style={{ marginBottom: 10 }}>
          <BackButton
            label={
              isRevshareView
                ? "revenue sharing"
                : event.is_virtual
                ? "virtual screenings"
                : "events"
            }
            onTouchTap={() =>
              isRevshareView
                ? this.context.router.push(`/revenue_sharing`)
                : this.props.location.state &&
                  this.props.location.state.fromListing
                ? this.context.router.goBack()
                : this.context.router.push(
                    `/event_buckets/${this.props.params.eventBucketId}${
                      event.is_virtual ? "/virtual_festival" : "/events"
                    }`
                  )
            }
          />
        </div>
        <div style={styles.header.main}>
          <div style={styles.header.text}>
            <div style={styles.header.buttonContainer}>
              <RaisedButton
                style={styles.header.button}
                label="Copy public link"
                onTouchTap={() => this.copyPublicLink(event.public_url)}
              />
              {event.is_virtual && !isRevshareView ? (
                <ViewLiveVirtualButton
                  style={styles.header.button}
                  label="View live"
                  href={event.public_url}
                />
              ) : (
                <RaisedButton
                  style={styles.header.button}
                  label="View live"
                  href={event.public_url}
                  target="_blank"
                />
              )}
              {!isRevshareView &&
              ((UserStore.hasPermission("edit_virtual_event") &&
                event.is_virtual) ||
                (UserStore.hasPermission("edit_physical_event") &&
                  !event.is_virtual)) ? (
                <RaisedButton
                  style={styles.header.button}
                  label="Edit"
                  onTouchTap={() =>
                    this.context.router.push(
                      `/event_buckets/${this.props.params.eventBucketId}/events/${this.props.params.eventId}/edit`
                    )
                  }
                  primary={true}
                />
              ) : null}
            </div>
            <h2 style={styles.header.textContent}>{event.name}</h2>
            {!event.is_virtual && (
              <h3 style={styles.header.textContent}>
                {event.venue.id ? (
                  <Link
                    style={styles.header.textContent}
                    to={`/event_buckets/${this.props.params.eventBucketId}/venues/${event.venue.id}`}
                  >
                    {event.venue.name}
                  </Link>
                ) : (
                  "No venue set"
                )}
              </h3>
            )}
            <h3 style={styles.header.textContent}>
              {makeEventDateRangeLabel(event)}
            </h3>
          </div>
        </div>

        {((UserStore.hasPermission("view_virtual_event") ||
          UserStore.hasPermission("edit_virtual_event")) &&
          !UserStore.hasRole("film_preview") &&
          event.is_virtual) ||
        ((UserStore.hasPermission("view_physical_event") ||
          UserStore.hasPermission("edit_physical_event")) &&
          !event.is_virtual) ? (
          <div>
            <Tabs
              value={this.state.tab}
              onChange={this.onChangeTab}
              style={{ clear: "both" }}
            >
              <Tab label="Insights" value="insights">
                {this.state.tab === "insights" && this._makeInsights()}
              </Tab>
              <Tab label="Tickets" value="tickets">
                {this.state.tab === "tickets" && this._makeTickets()}
              </Tab>
              <Tab label="Exports" value="exports">
                {this.state.tab === "exports" && this._makeExports(event)}
              </Tab>
            </Tabs>
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Event);



// WEBPACK FOOTER //
// ./src/app/components/event.jsx